import type { Sector } from '../../types/api';
import { CtaLink, ImageTile, Section } from '../ui';
import { summary } from '../../utils/text';

type Props = {
  sectors: Sector[];
  eyebrow?: string;
  heading?: string;
  limit?: number;
  background?: 'white' | 'surface';
};

/** Tuiles photo des secteurs: utilisées sur l'accueil (« Nos secteurs ») et sur les pages de service (« Secteurs associés »). */
export default function SectorsGrid({ sectors, eyebrow = 'Nos secteurs', heading = 'Là où nous intervenons', limit = 4, background = 'white' }: Props) {
  const list = sectors.filter((s) => s.enable && s.cover_image?.url).slice(0, limit);
  if (list.length === 0) return null;
  return (
    <Section eyebrow={eyebrow} heading={heading} background={background}>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {list.map((s, i) => (
          <ImageTile key={s.id} to={`/secteurs/${s.id}`} image={s.cover_image?.url} title={s.name} text={summary(s.description, 90)} delay={i * 0.08} />
        ))}
      </div>
      <div className="mt-12"><CtaLink to="/services">Voir tous nos services</CtaLink></div>
    </Section>
  );
}
